import { z } from 'zod'

export const bismillahConfigSchema = z.object({
    style: z.string().default('./src/index.css'),
    darkMode: z.boolean().default(true),
    theme: z.enum(['default', 'futuristic', 'neon']).default('futuristic'),
    componentsDir: z.string().default('./components'),
})

export const zodSchema = bismillahConfigSchema // Alias for compatibility

export type BismillahConfig = z.infer<typeof bismillahConfigSchema>
